const ActivityLogColumn = [
  {
    title: 'Date/Time',
    dataIndex: 'timestamp',
    scopedSlots: { customRender: 'timestamp' },
    width: 100
  },
  {
    title: 'User',
    dataIndex: 'conducted_by_username',
    width: 100
  },
  {
    title: 'Message',
    dataIndex: 'message',
    width: 250
  }
];

export { ActivityLogColumn };
